import _ from 'lodash';
import { createSelector } from 'reselect';

import CadminCompaniesAx from 'app/actions/company-admin/companies';
import ToastAx           from 'app/actions/toast';
import CadminApi         from 'app/apis/company-admin';
import CadminFormsDuck   from 'app/ducks/company-admin/forms';
import reducerUtils      from 'app/reducers/utils';
import CadminSlx         from 'app/selectors/company-admin/';
import EntitiesSlx       from 'app/selectors/entities';
import RoutingSlx        from 'app/selectors/routing';
import formsHelpers      from 'app/helpers/forms';


/*
 *  Actions
 */

const Types = {
  LOAD_PAGE_INDEX: 'CA_UI_FORMS_LOAD_PAGE_INDEX',
  LOAD_PAGE_NEW: 'CA_UI_FORMS_LOAD_PAGE_NEW',
  LOAD_PAGE_EDIT: 'CA_UI_FORMS_LOAD_PAGE_EDIT',
  LOAD_PAGE_SHOW: 'CA_UI_FORMS_LOAD_PAGE_SHOW',
  SET_BLDR_FORM: 'CA_UI_FORMS_SET_BLDR_FORM',
};

const Ax = {

  loadPageIndex: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(params.companySlug)),
      dispatch(CadminFormsDuck.Ax.loadAll(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_INDEX, promise});
  },

  loadPageNew: ({params}) => (dispatch, getState) => {
    const form = formsHelpers.makeNewForm();
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(params.companySlug)),
      dispatch(CadminFormsDuck.Ax.loadAll(params.companySlug)),
    ]);
    dispatch(Ax.setBldrForm(form));
    return dispatch({type: Types.LOAD_PAGE_NEW, promise,  formId: form.id});
  },

  setBldrForm: (form) => {
    const result = {bldrForm: form};
    return {type: Types.SET_BLDR_FORM, _entities: ['bldrForm'], result};
  },

  loadPageEdit: ({params}) => (dispatch, getState) => {
    const state = getState();
    const formsMap = EntitiesSlx.forms(state);
    // const form
    const loadAllProm = dispatch(CadminFormsDuck.Ax.loadAll(params.companySlug));
    loadAllProm.then(({forms}) => {
      const form = forms.find(f => f.id === params.formId);
      if (form) dispatch(Ax.setBldrForm(form));
    });
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(params.companySlug)),
      loadAllProm,
    ]);
    return dispatch({type: Types.LOAD_PAGE_EDIT, promise});
  },

  loadPageShow: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(params.companySlug)),
      dispatch(CadminFormsDuck.Ax.loadAll(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_SHOW, promise});
  },

};



/*
 *  Reducer
 */

const initialState = {
  pgNewFormId: null,
};

const reducer = reducerUtils.createReducer(initialState, {

  [`${Types.LOAD_PAGE_NEW}_PENDING`]: (state, action) => {
    return {...state,
      pgNewFormId: action.formId,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selPgNewFormId = (state) => state.companyAdmin.uiForms.pgNewFormId;

  const selPgNewForm = createSelector(
    [selPgNewFormId, EntitiesSlx.bldrForms],
    (id, formsMap) => {
      return formsMap[id] || null;
    }
  );

  const selPgEditForm = createSelector(
    [RoutingSlx.params, EntitiesSlx.bldrForms],
    (params, formsMap) => {
      return formsMap[params.formId] || null;
    }
  );

  return {
    pgNewForm: selPgNewForm,
    pgEditForm: selPgEditForm,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
